import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import { translations } from "../locales/index";

i18n
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    resources: translations,
    fallbackLng: 'pl',
    appendNamespaceToCIMode: true,
    saveMissing: true,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    debug: false,
    keySeparator: '### not used ###', // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: function(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      }
    },

    react: {
      wait: true,
      bindStore: false
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./constants/I18n.js